
export const htmlToText = (htmlString: string) => {
  if (htmlString.length > 0) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.innerText || '';
  }
  return '';
};

export const getAssigneName = (assignUserDetail: any, assigneType: any) => {
  if (!assignUserDetail || !assigneType) return '';
  if (assigneType === 'USER') {
    const { firstName, lastName, email, id, ProfileURL } = assignUserDetail;

    const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

    return { name: fullName || email || '', type: 'USER', id, ProfileURL };
  }
  if (assigneType === 'TEAM') {
    return {
      name: assignUserDetail.name,
      type: 'TEAM',
      id: assignUserDetail.id,
    };
  }
  return '';
};

export function getFlexibleUtcDateRange(startDays = 0, endDays = 0) {
  const MS_PER_DAY = 86400000;
  const now = Date.now();

  const startDate = new Date(now - startDays * MS_PER_DAY);
  const endDate = new Date(now - endDays * MS_PER_DAY);

  const from = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate()
  ).toISOString();

  const to = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate(),
    23,
    59,
    59,
    999
  ).toISOString();

  return { from, to };
}

export const getProfileUrl = (channelType: string) => {
  switch (channelType?.toUpperCase()) {
    case 'WHATSAPP':
      return 'ic:baseline-whatsapp';

    case 'EMAIL':
      return 'material-symbols:mail-rounded';

    case 'VOICE':
      return 'ci:user-voice';

    case 'LIVE_CHAT':
      return 'material-symbols:video-chat';

    case 'INSTAGRAM':
      return 'mdi:instagram';

    case 'MESSENGER':
      return 'mingcute:messenger-fill';

    case 'LINE':
      return 'mage:line';

    case 'SMS':
      return 'fa-solid:sms';

    case 'TELEGRAM':
      return 'ic:baseline-telegram';

    default:
      return ''; // fallback
  }
};

export function formatDate({
  dateString,
  type = 'date',
  months,
}: {
  dateString: string;
  type: 'hours' | 'date' | 'month';
  months: string[];
}): string {
  if (type === 'hours') {
    return dateString;
  }

  if (type === 'date') {
    const dateObj = new Date(dateString);
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = months[dateObj.getMonth()];
    return `${day} ${month}`;
  }

  if (type === 'month') {
    const [yearStr, monthStr] = dateString.split('-');
    const monthIndex = parseInt(monthStr, 10) - 1;
    const month = months[monthIndex];
    return `${month} ${yearStr}`;
  }

  return dateString;
}

export function removeEmptyKeys(obj: any) {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== null && value !== '' && value !== undefined
    )
  );
}

export const localTimeZone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;

export const cleanHtml = (html: string) =>
  html
    .replace(/<br\s*\/?>/gi, '') // remove <br>
    .replace(/&nbsp;/gi, '') // remove HTML spaces
    .replace(/<[^>]+>/g, '') // remove tags
    .trim();

export const markdownToHtml = (text: string) => {
  if (!text) return '';

  let html = text;

  // Bold: **text**
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

  // Italic: *text*
  html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');

  // Line breaks → <br>
  html = html.replace(/\n/g, '<br>');

  // Paragraphs: split by two line breaks
  html = html.replace(/<br>\s*<br>/g, '</p><p>');

  // Wrap in <p>
  html = `<p>${html}</p>`;

  return html;
};

export const getUserDisplayName = (user: any) => {
  if (!user) return '';
  const { name, firstName, lastName, email } = user;
  if (name) return name;
  if (firstName || lastName) return `${firstName ?? ''} ${lastName ?? ''}`.trim();
  return email ?? '';
};
